// extracted by mini-css-extract-plugin
export var filterIncDec = "_3e-0";
export var leftBorder = "_3e-1";
export var rightBorder = "_3e-2";
export var stringInput = "_3e-3";